module.exports = __webpack_public_path__ + "img/yachthouse_gtcompany.714202c0.jpg";